// extracted by mini-css-extract-plugin
export default {"diagramArea":"canvas_diagramArea__oQnw7"};